:host {
  display: block;
  @include label-font-100;
  width: 100%;
}

.feasibility-box {
  color: var(--cms-semanticColors-base-strong-text);
  max-width: var(--cms-container-max-width);
  padding: var(--cms-spacing-075);
  border: var(--cms-border-size-xs) solid var(--cms-semanticColors-transparency-strong-border);
  display: flex;
  flex-direction: column;
  margin: 0 auto;
}

.feasibility-challenge,
.feasibility-work-time,
.feasibility-doer,
.feasibility-project-price {
  display: flex;
  flex-flow: row wrap;
  width: 100%;
  justify-content: flex-start;
  align-items: center;
}

.svg-wrapper {
  flex: 0 0 2.5rem;
}

.feasibility-label,
.feasibility-value {
  flex: 0 0 var(--cms-one-third-width);
}

.feasibility-value {
  margin-left: var(--cms-spacing-075);
  text-align: left;
  font-size: var(--cms-font-size-125);
  line-height: var(--cms-line-height-111);
  font-family: var(--cms-brandfont1);
}

.dot {
  border-radius: css-var(border-radius-20-percent);
  height: px-to-rem(5);
  width: px-to-rem(15);
  margin-right: var(--cms-spacing-025);
  background-color: var(--cms-semanticColors-primary-background);
  display: inline-block;
}

.blank-dot {
  border-radius: css-var(border-radius-20-percent);
  margin-right: var(--cms-spacing-025);
  background-color: var(--cms-semanticColors-base-strong-background);
  display: inline-block;
}